<template>
  <div class="news-list">
    <h2>新闻管理</h2>
    <el-tabs v-model="activeTab">
      <el-tab-pane label="已发布" name="published">
        <el-table :data="publishedNews" style="width: 100%">
          <el-table-column prop="title" label="标题" />
          <el-table-column prop="author" label="作者" />
          <el-table-column prop="created_at" label="发布时间" />
          <el-table-column label="操作">
            <template #default="scope">
              <el-button size="small" type="primary" @click="editNews(scope.row.id)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="草稿" name="draft">
        <el-table :data="draftNews" style="width: 100%">
          <el-table-column prop="title" label="标题" />
          <el-table-column prop="author" label="作者" />
          <el-table-column prop="updated_at" label="更新时间" />
          <el-table-column label="操作">
            <template #default="scope">
              <el-button size="small" type="primary" @click="editNews(scope.row.id)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
export default {
  setup() {
    const activeTab = ref('published')
    const publishedNews = ref([])
    const draftNews = ref([])
    const router = useRouter()
    const fetchNews = async () => {
      publishedNews.value = (await axios.get('/api/news?status=published')).data
      draftNews.value = (await axios.get('/api/news?status=draft')).data
    }
    const editNews = (id) => {
      router.push(`/news/edit/${id}`)
    }
    onMounted(fetchNews)
    return { activeTab, publishedNews, draftNews, editNews }
  }
}
</script>
